import { createStore, applyMiddleware } from "redux"
import { composeWithDevTools } from "redux-devtools-extension"
import thunk from "redux-thunk"
import { persistStore } from "redux-persist"
import rootReducer from "./redux/reducers/root-reducer"

// prevent auth error on first run of subscription
const initialState = { auth: { token: null } }

const middlewares = [thunk]

export const store = createStore(
  rootReducer,
  initialState,
  composeWithDevTools(applyMiddleware(...middlewares))
)

export const persistor = persistStore(store)

export default { store, persistor }
